var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout",
    transform: "translate(1435 485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sign_out",
    "data-name": "Sign out",
    transform: "translate(-1432 -482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6231",
    "data-name": "Rectangle 6231",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_343",
    "data-name": "Union 343",
    d: "M0,12.678A10.413,10.413,0,0,1,6.495,3.1a1.22,1.22,0,0,1,1.579.613,1.135,1.135,0,0,1,.011.895,1.178,1.178,0,0,1-.642.641A8.076,8.076,0,0,0,2.4,12.678,7.924,7.924,0,0,0,4.834,18.4a8.5,8.5,0,0,0,11.764,0,7.93,7.93,0,0,0,2.431-5.722A8.078,8.078,0,0,0,13.99,5.245a1.164,1.164,0,0,1-.715-1.318A1.2,1.2,0,0,1,14.452,3h.022a1.224,1.224,0,0,1,.469.1,10.412,10.412,0,0,1,6.486,9.58A10.582,10.582,0,0,1,10.716,23.1,10.584,10.584,0,0,1,0,12.678Zm9.865-1.7a1.15,1.15,0,0,1-.35-.827V1.181a1.134,1.134,0,0,1,.34-.826A1.205,1.205,0,0,1,10.7,0h.02a1.212,1.212,0,0,1,.849.343,1.161,1.161,0,0,1,.352.845v8.966a1.187,1.187,0,0,1-1.2,1.17A1.22,1.22,0,0,1,9.865,10.981Z",
    transform: "translate(5.285 4.45)",
    fill: "#ccdce6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logout-2",
    "data-name": "logout",
    transform: "translate(-1435 -485)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.081
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.4144bf304ee20b59b05c02ae0bd74307.svg";
export { ForwardRef as ReactComponent };